import { type FC, useState, useEffect } from 'react';
import BaseInput from 'components/atoms/base-input';
import { useDebounce } from 'react-use';

import s from './styles.module.scss';

interface Props {
  value: string | undefined;
  onChange: (value: string) => void;
  label: string;
  id: string;
  placeholder: string;
}

const Input: FC<Props> = ({ value, onChange, label, id, placeholder }) => {
  const [inputValue, setInputValue] = useState(value || '');

  useDebounce(
    () => {
      onChange(inputValue);
    },
    400,
    [inputValue],
  );

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  return (
    <div style={{ width: '100%' }}>
      <div className={s['interaction-date-range']}>
        <label htmlFor={id}>{label}</label>
        <div className={s['input-wrapper']}>
          <BaseInput
            id={id}
            allowClear
            value={inputValue}
            onChange={(e) => setInputValue(e)}
            placeholder={placeholder}
          />
        </div>
      </div>
    </div>
  );
};

export default Input;
